import { render, staticRenderFns } from "./01.vue?vue&type=template&id=3ab19cc1&"
import script from "./01.vue?vue&type=script&lang=js&"
export * from "./01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports